import { __ } from '@wordpress/i18n';
import { Select } from '../components/select';
import  RadioControl  from '../components/radio-control';
import clsx from 'clsx';
import {
	ValidatedTextInput,
	CheckboxControl,
} from '@woocommerce/blocks-components';
import { useRef, useEffect } from 'react';
import { createFieldProps, createCheckboxFieldProps } from '../utils/utils-functions';
import customValidationHandler  from '../components/custom-validation-handler';
import ParagraphField from '../components/paragraph-field';
import HeadingField from '../components/heading-field';
import TextareaField from '../components/textarea';

const EditFields = ( {field, onChange = ''} ) => {

    const { id, label, type, value, placeholder, required, options, title, validate, property_set, enabled, cssclass } = field;
    const { default : defaultValue , checked } = property_set;

	const fieldProps = createFieldProps( field );
	const fieldsRef = useRef( {} );

    if (!enabled || enabled === '0') {
		return null;
	}

    const handleChange = (newValue) => {
        
    };

    if (type === 'email' && id === 'email') {
        return null;
    }

    if (type === 'checkbox') {

        return (
            <CheckboxControl
                key={id}
                checked={value}
                onChange={handleChange}
                {...createCheckboxFieldProps(fieldProps)}
                className={clsx(
                    cssclass?.split(',').map(className => className.trim())
                )}
               required={required}
            />
        );
    }

    if ( type === 'select' && field.options) {	
        return (
            <Select
                key={ id }
                { ...fieldProps }
                label = {title || ''}
                className={clsx(
                    cssclass?.split(',').map(className => className.trim()),
                    'wc-block-components-select-input',
                    `wc-block-components-select-input-${id}`.replaceAll('/', '-')
                )}
                value={ value }
                onChange={handleChange}
                options={ fieldProps.options }
                required={ required }
                errorMessage={fieldProps.errorMessage || undefined}
                placeholder={placeholder|| null}
            />
        );
    }
		
	if ( type === 'radio' ) {
        return (	
            <RadioControl
                { ...fieldProps }
                selected={ value }
                onChange={handleChange}
                options={fieldProps.options}
                disabled={false}
                highlightChecked={true}
                title={title || ''}
                className={clsx(
                    cssclass?.split(',').map(className => className.trim())
                )}
            />
        );
    }

    if ( type === 'paragraph' ) {
        return <ParagraphField field={ field } />;
    }

    if ( type === 'heading' ) {
        return <HeadingField field={ field } />;
    }

    if ( type === 'textarea' ) {
        return ( <TextareaField field={field} value={value} onChange={handleChange} required={required}/>  );
    }

    return (
        <ValidatedTextInput
            key={ id }
            ref={ ( el ) =>
                ( fieldsRef.current[ id ] = el )
            }
            { ...fieldProps }
            type={ type }
            value={ value }
            onChange={handleChange}
            className={clsx(
                cssclass?.split(',').map(className => className.trim())
            )}
            customFormatter={ ( value  ) => {
            	if ( field.type === 'postcode' ) {
            		return value.trimStart().toUpperCase();
            	}
            	return value;
            } }
            customValidation={ ( inputObject ) =>
            	customValidationHandler(
            		inputObject,
            		validate,
            	)
            }
        />
    );
};

export default EditFields;

